import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './podcasts.component.scss';
import * as Swiper from 'swiper/dist/js/swiper.js';
var Podcasts = /** @class */ (function (_super) {
    tslib_1.__extends(Podcasts, _super);
    function Podcasts(element) {
        return _super.call(this, element) || this;
    }
    Podcasts.prototype.init = function () {
        if (this.element.querySelector('.podcasts__list--swiper')) {
            this.podcastListContainer = this.element.querySelector('.podcasts__list--swiper');
            this.podcastList = new Swiper(this.podcastListContainer, {
                slidesPerView: 1.2,
                centeredSlides: false,
                spaceBetween: 30,
                initialSlide: 0,
                breakpoints: {
                    1201: {
                        initialSlide: 0,
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                    1025: {
                        initialSlide: 0,
                        slidesPerView: 2.5,
                        spaceBetween: 30,
                    },
                    768: {
                        initialSlide: 0,
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    581: {
                        initialSlide: 0,
                        slidesPerView: 2,
                        spaceBetween: 10,
                    },
                    481: {
                        initialSlide: 0,
                        slidesPerView: 1.5,
                        spaceBetween: 10,
                    }
                },
                freeMode: false,
                pagination: {
                    el: this.element.querySelector('.swiper-pagination'),
                    type: 'bullets',
                    clickable: true
                },
                navigation: {
                    nextEl: this.element.querySelector('.swiper-button-next'),
                    prevEl: this.element.querySelector('.swiper-button-prev')
                }
            });
        }
    };
    Podcasts.prototype.bindEvents = function () {
    };
    return Podcasts;
}(Base));
export { Podcasts };



//////////////////
// WEBPACK FOOTER
// ./components/podcasts/podcasts.component.ts
// module id = 761
// module chunks = 0